import { Injectable } from '@angular/core';
import { AALocationModel, RoutePlannerDataModel } from '../../models/route-model';
import { Enums } from '../../enums/route.enum';
import { AppError } from 'src/app/core/models/constants';
import { RoutePlannerService } from '../route-planner/route-planner.service';
import { EventsService } from 'src/app/core/services/events.service';
import { RouteValidationMessage } from 'src/app/core/events/events';

@Injectable({
  providedIn: 'root'
})
export class LocationManagerService  {

  public fromLocation: AALocationModel;
  public toLocation: AALocationModel;
  public viaPoints: Array<AALocationModel> = [];
  public routeDataModel: RoutePlannerDataModel;
  public generalErrorMessage = '';

  constructor(private routePlannerService: RoutePlannerService,
    private eventsService: EventsService) {
    this.routeDataModel = this.routePlannerService.routeDataModel;
    this.fromLocation = this.routeDataModel.FromLocation;
    this.toLocation = this.routeDataModel.ToLocation;
  }

  public setLocationModel(locationModel: AALocationModel): void {
    switch (locationModel.RouteType) {
      case Enums.RouteType.FromDestination:
        this.fromLocation.Name = locationModel.Name;
        this.fromLocation.Latitude = locationModel.Latitude;
        this.fromLocation.Longitude = locationModel.Longitude;
        break;

      case Enums.RouteType.ToDestination:
        this.toLocation.Name = locationModel.Name;
        this.toLocation.Latitude = locationModel.Latitude;
        this.toLocation.Longitude = locationModel.Longitude;
        break;
    }
  }

  public validateLocationByName(locationModel: AALocationModel): boolean {
    if (locationModel.Name !== '' && locationModel.Name.length > 2) {
      return true;
    }
    return false;
  }

  public resetLocation(locationModel: AALocationModel): void {
    locationModel.PredictionList = [];
    locationModel.hasError = false;
    locationModel.clear();
  }

  private invalidateErrorMessage(locationModel: AALocationModel): void {
    locationModel.errorMessage = (locationModel.isCurrentLocation())
      ? AppError.LOCATION_ACCESS_FEATURE_TURNON : AppError.VIA_ROUTE_MISSING;
  }

  // validate
  public validateFromToLocation(): boolean {
    let validationSuccess = true;

    this.fromLocation.validateLocationName();
    if (this.fromLocation.validName() === false) {
      this.fromLocation.hasError = true;
      this.invalidateErrorMessage(this.fromLocation);
      validationSuccess = false;
    }

    this.toLocation.validateLocationName();
    if (this.toLocation.validName() === false) {
      this.toLocation.hasError = true;
      this.invalidateErrorMessage(this.toLocation);
      validationSuccess = false;
    }
    return validationSuccess;
  }
}
